import { useState, useEffect } from "react";
import { Button, Card, Container, Spinner, Alert } from "react-bootstrap";
import { loginToLms } from "../../../utils/SsoLogin";
import { Helmet } from "react-helmet-async";
import { BookOpen } from "react-feather";
import LMS from "../../../assets/img/LMS.jpg"

const Lms = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const queryParameters = new URLSearchParams(window.location.search);
    const lmsLogin = queryParameters.get("lms-login");

    const handleLogin = async () => {
        setError(null);
        setLoading(true);

        try {
            await loginToLms();
        } catch (err) {
            setError("Unable to log in to LMS right now. Please try again.");
            console.error("LMS SSO login failed:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (lmsLogin) {
            handleLogin();
        }
    }, [lmsLogin]);

    return (
        <>
            <Helmet title="LMS Login" />
            <Container fluid className="py-4">
                <h3 className="mb-4">Learning Management System</h3>

                <Card>
                    <Card.Header className="text-center py-4">
                        <BookOpen size={48} className="mb-3 text-primary" />

                        <Card.Title as="h5" className="mb-2">
                            Access the LMS
                        </Card.Title>
                        <Card.Text className="text-muted mb-4">
                            You're logged in to TMS. Click below to
                            open the LMS in a new tab — you'll be signed in
                            automatically.
                        </Card.Text>

                        {error && (
                            <Alert variant="danger" className="text-start">
                                {error}
                            </Alert>
                        )}

                        <Button
                            onClick={handleLogin}
                            disabled={loading}
                            size="lg"
                        >
                            {loading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        className="me-2"
                                    />
                                    Logging in...
                                </>
                            ) : (
                                "Login to LMS"
                            )}
                        </Button>
                    </Card.Header>

                    <Card.Body className="text-center py-5">
                        <img
                            src={LMS}
                            alt="LMS preview"
                            className="img-fluid"
                        />
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
};

export default Lms;
